import {Component} from '@angular/core';

@Component({
  selector: 'app-regional-budget',
  styleUrls: ['./regional-budget.component.scss'],
  templateUrl: './regional-budget.component.html'
})
export class RegionalBudgetComponent {
  public columns: string[];

  constructor() {
    this.columns = [
      'regional_name',
      'inspector_name',
      'sales_group_id',
      'material_name',
      'category_name',
      'is_led_name',
      'returns_to_repair',
      'returns_ready',
    ];
  }
}
